import React, { Component } from 'react';
import './header.css';
import logo from '../../assets/img/logo.svg';

class Header extends Component {
  render() {
    return (
      <header className="header">
        <a
          href="https://ppc.world/"
          target="_blank"
          rel="noopener noreferrer"
          className="header__logo-wrapper"
        >
          <img src={logo} alt="" className="header__logo-img" />
        </a>
      </header>
    );
  }
}

export default Header;
